import { createContext } from 'react';
import { noop } from 'helpers/utility';
export const InternationalBeneficiaryValidationContext = createContext({
    triggerValidation: noop,
    validationInfo: null,
    validationErrors: null,
});
